/* 🤖 this file was generated by svg-to-ts */
export const siriusBinoculars: {
  name: 'binoculars';
  data: string;
} = {
  name: 'binoculars',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M22.238 14.238a4.41 4.41 0 0 0-.22-.511l-3.9-8.87a.734.734 0 0 0-.155-.23 3 3 0 0 0-4.244 0 .75.75 0 0 0-.219.53V7.5h-3V5.156a.75.75 0 0 0-.22-.53 3 3 0 0 0-4.242 0 .733.733 0 0 0-.156.228l-3.9 8.87A4.5 4.5 0 1 0 10.5 15.75V9h3.001v6.75a4.5 4.5 0 1 0 8.738-1.511ZM7.192 5.6A1.5 1.5 0 0 1 9 5.508v6.891a4.49 4.49 0 0 0-4.387-.93l2.579-5.868ZM6 18.75a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm9-13.243a1.5 1.5 0 0 1 1.808.094l2.579 5.866a4.49 4.49 0 0 0-4.387.931V5.507Zm3 13.243a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" fill="currentColor"/></svg>`
};
